import { createPortal } from "react-dom";
import OpticksNotificationsItem from "./OpticksNotificationsItem";
import { useNotificationStore } from "@/zustand/notificationsStore";
import "./OpticksNotifications.css";

interface Props {
  inline?: boolean;
}

const OpticksNotifications = ({ inline = false }: Props) => {
  const { notifications } = useNotificationStore();

  if (notifications.length === 0) return null;

  const container = (
    <div className="notification-container">
      {notifications
        .filter((notification) => typeof notification.id === "string")
        .map((notification) => (
          <OpticksNotificationsItem
            key={notification.id as string}
            notification={{ ...notification, id: notification.id as string }}
          />
        ))}
    </div>
  );

  return inline ? container : createPortal(container, document.body);
};

export default OpticksNotifications;
